const fromQueryPlaceDetailsToPlaceDetails = (data)=>{
    if (!data) {
        return null;
    }
    var _city, _country, _countryCode, _postalCode, _province, _provinceShort, _streetName, _streetNumber;
    return {
        id: data.id,
        city: (_city = data.city) !== null && _city !== void 0 ? _city : undefined,
        country: (_country = data.country) !== null && _country !== void 0 ? _country : undefined,
        countryCode: (_countryCode = data.countryCode) !== null && _countryCode !== void 0 ? _countryCode : undefined,
        postalCode: (_postalCode = data.postalCode) !== null && _postalCode !== void 0 ? _postalCode : undefined,
        province: (_province = data.province) !== null && _province !== void 0 ? _province : undefined,
        provinceShort: (_provinceShort = data.provinceShort) !== null && _provinceShort !== void 0 ? _provinceShort : undefined,
        streetName: (_streetName = data.streetName) !== null && _streetName !== void 0 ? _streetName : undefined,
        streetNumber: (_streetNumber = data.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : undefined
    };
};

export { fromQueryPlaceDetailsToPlaceDetails };
//# sourceMappingURL=fromQueryPlaceDetailsToPlaceDetails.js.map
